import { createContext, useContext } from "react";

import type { ChannelName } from "../../../../channels/types";
import type { Selection } from "./use-co-pilot-types";

export interface CoPilotPanelParams {
  anchorPosition: { top: number; left: number };
  capturedSelection: Selection | undefined;
  channel: NonNullable<ChannelName>;
  format: "email" | "chat" | "sms";
}

interface CoPilotToolbarContextType {
  openPanel: (params: CoPilotPanelParams) => void;
  closePanel: () => void;
  panelState: CoPilotPanelParams | null;
}

export const CoPilotToolbarContext = createContext<CoPilotToolbarContextType>({
  openPanel: () => {},
  closePanel: () => {},
  panelState: null,
});

export function useCoPilotToolbarContext(): CoPilotToolbarContextType {
  return useContext(CoPilotToolbarContext);
}
